import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import ActionButton from '@/components/action_button/Index.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import NumericInput from '@/components/v2/NumericInput.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import { required, decimal } from 'vuelidate/lib/validators';
import { requiredProperty } from '@/helpers/mixins/LocalizationHelper';
import { Getter } from 'vuex-class';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let CartAddOnForm = class CartAddOnForm extends Mixins(FormMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.form = {
            name: null,
            price: null,
            requiredPerOrder: false,
        };
    }
    get action() {
        return this.update ? 'Edit' : 'Create';
    }
    get nameErrors() {
        const errors = [];
        if (!this.$v.form.name.$dirty) {
            return errors;
        }
        if (!this.$v.form.name.required) {
            const msg = requiredProperty('Name');
            errors.push(msg);
        }
        return errors;
    }
    get priceErrors() {
        const errors = [];
        if (!this.$v.form.price.$dirty) {
            return errors;
        }
        if (!this.$v.form.price.required) {
            const msg = requiredProperty('Price');
            errors.push(msg);
        }
        return errors;
    }
    onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.$emit('submit', this.form);
        }
    }
    mounted() {
        if (this.formData) {
            this.form = { ...this.formData };
        }
    }
};
__decorate([
    Getter('requestOnFlight')
], CartAddOnForm.prototype, "mutationRequestOnFlight", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CartAddOnForm.prototype, "update", void 0);
__decorate([
    Prop({ type: Object, default: null })
], CartAddOnForm.prototype, "formData", void 0);
CartAddOnForm = __decorate([
    Component({
        components: {
            ActionButton,
            FormHeader,
            NumericInput,
            BaseTextField,
        },
        validations: {
            form: {
                name: {
                    required,
                },
                price: {
                    decimal,
                    required,
                },
                requiredPerOrder: {},
            },
        },
    })
], CartAddOnForm);
export default CartAddOnForm;
